import { Stream } from '@/types/streams'

export abstract class StreamChangeHandler {
  constructor () {}

  abstract handleChanges (oldStream: Stream|null, newStream: Stream): void
}
